import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "Management",
      desc: "Efficiently plan, organize, and oversee tasks to achieve specific project goals and deadlines.",
      icon: "fas fa-tasks",
    },
    {
      name: "Business",
      desc: "Develop effective plans to ensure organizational growth and achieve long-term success.",
      icon: "fas fa-briefcase",
    },
    {
      name: "Analytical",
      desc: "Analyze data patterns to drive informed decision-making and enhance performance.",
      icon: "fas fa-chart-line",
    },
    {
      name: "Negotiating",
      desc: "Master the art of creating win-win solutions through effective communication techniques.",
      icon: "fas fa-handshake",
    },
    {
      name: "Financial",
      desc: "Optimize budgeting, investments, and expenses to ensure financial stability and growth.",
      icon: "fas fa-calculator",
    },
    {
      name: "Technical",
      desc: "Provide innovative solutions and ensure seamless operations with technical proficiency.",
      icon: "fas fa-cogs",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do?</span>
        </p>
        {/* <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2> */}
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
